(() => {
  const trackedCardForms = [
    '.mkg-cart-form',
    '.mpe-atc-form',
    '.mpr-atc-form',
    '.mcc-atc-form',
  ].join(',');

  const cartRoot = () => {
    const root = window.Shopify?.routes?.root || '/';
    return root.endsWith('/') ? root : `${root}/`;
  };

  document.addEventListener('click', async (event) => {
    const submitButton = event.target.closest('button[type="submit"]');
    const form = submitButton?.closest(trackedCardForms);
    if (!form || form.dataset.magicCartSubmitting === 'true') return;

    // Cancel the button's native submit action. A submit event would make the
    // Google app emit an incomplete conversion before the AJAX response exists.
    event.preventDefault();
    form.dataset.magicCartSubmitting = 'true';
    submitButton.disabled = true;
    submitButton.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(`${cartRoot()}cart/add.js`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: new FormData(form),
      });
      const payload = await response.json();

      if (!response.ok) {
        throw new Error(payload.description || payload.message || 'Produsul nu a putut fi adăugat în coș.');
      }

      // Shopify's Google app enriches product_added_to_cart from the AJAX response.
      // Keep the current card UX (redirect to cart), but leave time for its beacon.
      await new Promise((resolve) => setTimeout(resolve, 350));
      window.location.assign(`${cartRoot()}cart`);
    } catch (error) {
      delete form.dataset.magicCartSubmitting;
      submitButton.disabled = false;
      submitButton.removeAttribute('aria-busy');
      window.alert(error.message || 'Produsul nu a putut fi adăugat în coș.');
    }
  });
})();
